<template>
    <div>
        <datatable tablename="datatable-carehome-patient-list" :columns="columns" :source="getRecords" :datachanged="carehomeid" @selected="recordSelected"></datatable>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { PatientDto } from './../../../dto/PatientDto'
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"

    export default {
        props: ['carehomeid'],
        data: function () {
            var formatDate = Formatter.FormatDate;
            return {
                columns: [
                    {
                        name: "Name", render: function (data, type, row) {
                            if (type === "sort" || type === 'type') {
                                return row.lastName;
                            }

                            var link = '/patient/' + row.id + '/' + row.carehomeId + '/'

                            return "<div class='btn-group btn-xs'>																			"
                                + "  <a class='btn btn-link dropdown-toggle btn-xs' data-toggle='dropdown' aria-expanded='true'>	"
                                +    (row.lastName || "") + ", " + (row.firstName || "") + " " + (row.middleName || "") + " " + (row.title || "")
                                //+ "    <span class='caret'></span>																		"
                                + "  </a>																								"
                                + "  <ul class='dropdown-menu'>																			"
                                + "    <li><a href='" + link + "medprofile'>Med Profile</a></li>															    "
                                + "    <li><a href='" + link + "medstock'>Med Stock</a></li>															    "
                                + "    <li><a href='" + link + "orders'>Orders</a></li>															        "
                                + "    <li><a href='" + link + "reports'>Charts</a></li>															    "
                                + "    <li><a href='" + link + "marhistory'>Mar History</a></li>															    "
                                + "   </ul>																								"
                                + "</div>																								"
                                // (row.lastName || "") + ", " + (row.firstName || "") + " " + (row.middleName || "") + " " + (row.title || "")
                        }
                    }
                    , {
                        name: "Status", data: "status", render: function (data, type, row) {

                            return "<span class='pull-left'>" + data + "</span>" + (row.statusFrom ? "</br>" : "") + (row.statusFrom ? "<small class='pull-left'>(" + formatDate(row.statusFrom) + ")</small>" : "")
                        }
                    }
                    //, { name: "StatusFrom", data: "statusFrom" }
                    , {
                        name: "DateOfBirth", data: "dob", render: function (data, type, row) {
                            if (type === "sort" || type === 'type') {
                                return data;
                            }
                            return Formatter.FormatDate(data);
                        }
                    }
                    , { name: "Sex", data: "sex" }
                    , { name: "Nhs Number", data: "nhsNumber" }
                    , {
                        name: "General Practitioner",
                        data: "generalPractitioner",
                        render: function (data) {
                            return (!data.name) ? "" : data.name + "<br/>"
                        }
                    }
                    , {
                        name: "Ward", render: function (data, type, row) {
                            return row.wardName || "";
                        }
                    }
                    , { name: "Room Number", data: "roomNumber" }
                    , { name: "WhenCreated", data: "whenCreated", render: Formatter.FormatDate }
                ]
            }
        },
        mounted: function () {
            console.log("patient list mounted with id " + this.carehomeid)

        },
        methods: {
            //formatDate: function (dt) {
            //    return Formatter.FormatDate(dt);
            //},
            getRecords: function (callback) {
                var dal = new Dal();
                dal.GetPatients(this.carehomeid).then(data => {
                    console.log("Loading Patient Data for id: " + this.carehomeid)
                    var records = { data: data };
                    callback(records);
                });
            },

            recordSelected: function (record) {
                var id = record.id;
                //this.$router.push({ name: 'patient-main', params: { id: id, carehomeid: this.carehomeid } })
                //this.$router.push({ name: 'patient.orders', params: { patientid: id, carehomeid: this.carehomeid } })
            }
        },
        components: {
            datatable,
            Formatter
        }
    }
</script>


// WEBPACK FOOTER //
// carehome-patient-list.scp.html?64173fa0